import React from "react"
import { Badge, Box, Flex, Grid, Heading, Text } from "@theme-ui/components"
import { getArticlePath } from "../utils/path"
import { GatsbyImage } from "gatsby-plugin-image"
import { InboundLink } from "./link"
import { render } from "datocms-structured-text-to-plain-text"

const ArticleThumb = ({ theme = "dark", article, small }) => {
  return (
    <Box
      sx={{
        height: "100%",
        backgroundColor: theme === "light" ? "#fafafa" : "light",
        borderRadius: "0 20px",
      }}
    >
      <InboundLink
        to={getArticlePath(article, article.locale)}
        sx={{
          textDecoration: "none",
          boxShadow: "0px 10px 10px -10px rgba(50,50,93,0.15)",
          transition: ".2s all ease-in-out",
          "&:hover": {
            boxShadow: "0px 10px 20px -10px rgba(50,50,93,0.20)",
            ".gatsby-image-wrapper": { opacity: 0.8 },
          },
        }}
      >
        <Grid columns={[1, small ? 1 : "5fr 3fr"]} gap={0}>
          <Box
            sx={{
              position: "relative",
              ".gatsby-image-wrapper": {
                minHeight: "250px",
                maxHeight: "250px",
                borderRadius: "0 20px",
                transition: ".2s opacity ease-in-out",
              },
            }}
          >
            {article.heroImage && (
              <GatsbyImage image={article.heroImage.gatsbyImageData} alt="" />
            )}
          </Box>
          <Flex
            sx={{
              p: [3, 4],
              mt: [1, 1],
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            {article.category.originalId === "DsYWb7w9R3S89H1ccm-0kw" && (
              <Badge sx={{ mb: [3] }}>{article.category.title}</Badge>
            )}
            <Heading
              as="h2"
              variant="h4"
              sx={{ mb: [3], mt: 0, color: "text", fontWeight: "700" }}
            >
              {article.title.length > 120
                ? article.title.substring(0, 120) + "..."
                : article.title}
            </Heading>
            {article.meta &&
              article.meta.firstPublishedAt &&
              article.category.originalId !== "DsYWb7w9R3S89H1ccm-0kw" && (
                <Text sx={{ fontSize: [1], mb: [2] }}>
                  {article.meta.firstPublishedAt}
                </Text>
              )}
            <Text
              as="p"
              sx={{ fontSize: 2, color: "dark", fontWeight: "200" }}
            >
              {render(article.body)
                ? render(article.body).substring(0, 180) + " ..."
                : ""}
            </Text>
          </Flex>
        </Grid>
      </InboundLink>
    </Box>
  )
}

export default ArticleThumb
